import { FC } from "react";
import style from "./style.module.css";

interface Props {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  totalItems?: number;
}

// Small hand-rolled Prev/Next + page-number control — no pagination library
// in this app, and this is simple enough not to need one.
const Pagination: FC<Props> = ({ page, totalPages, onPageChange, totalItems }) => {
  if (totalPages <= 1) return null;

  // Keeps the page-number strip short even with many pages: current page,
  // one neighbor on each side, and the first/last page, with "…" gaps.
  const pageNumbers: (number | "...")[] = [];
  for (let p = 1; p <= totalPages; p++) {
    if (p === 1 || p === totalPages || Math.abs(p - page) <= 1) {
      pageNumbers.push(p);
    } else if (pageNumbers[pageNumbers.length - 1] !== "...") {
      pageNumbers.push("...");
    }
  }

  return (
    <div className={style.pagination}>
      {typeof totalItems === "number" && (
        <span className={style.totalText}>{totalItems} total</span>
      )}
      <button
        className={style.navBtn}
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
      >
        Prev
      </button>
      {pageNumbers.map((p, i) =>
        p === "..." ? (
          <span key={`ellipsis-${i}`} className={style.ellipsis}>…</span>
        ) : (
          <button
            key={p}
            className={p === page ? style.pageBtnActive : style.pageBtn}
            onClick={() => onPageChange(p)}
          >
            {p}
          </button>
        )
      )}
      <button
        className={style.navBtn}
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
